import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormLabel from '@mui/material/FormLabel';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import dynamic from 'next/dynamic';
import React, { useEffect, useState } from 'react';
import { getUser } from '../../helpers/token';
import PostSocialShares from './PostSocialShares';

const NewBadgePopup = dynamic(() => import('../Dashboard/NewBadgePopup'), {
  ssr: false,
});

const LargeSocialShareDialog = props => {
  const [open, setOpen] = useState(false);

  const { author, permlink, tags, title, thumbnail, createdAt } = props;

  useEffect(() => {
    const isNew = new Date(new Date().getTime() - 60000) < new Date(createdAt);
    if (isNew && author === getUser()) setOpen(true);
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {open && <NewBadgePopup />}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="text-center" id="form-dialog-title">
          Share your post!
          <div
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              padding: '2px',
            }}
          >
            <IconButton onClick={handleClose} aria-label="Close" size="large">
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <FormLabel component="legend">
            Did you know that you can significantly increase the reach of your
            post by promoting it on social media along with a personal message
            to your followers? With the sharing buttons below, sharing your post
            is only one click away!
          </FormLabel>
          <PostSocialShares
            author={author}
            permlink={permlink}
            tags={tags}
            title={title}
            thumbnail={thumbnail}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default LargeSocialShareDialog;
